import { autoinject, bindable } from "aurelia-framework";

@autoinject
export class AccountingRuleTypeSelector {
	@bindable allowAddingAutomaticTypeRecognitionRule: boolean;
	@bindable ruleType: string;
	@bindable allowChangeOfRuleType: boolean = true;
}
